import { sortBy } from 'lodash';
import React from 'react';
import { arrayOfIds } from '../../../lib/helpers';
import { groupBySubject } from '../../../lib/measurement-group';
import Tracker from './Tracker';

interface IMeasurementBySubjectProps {
  measurements: {
    subject: {
      id: string;
    };
    tracker: {
      id: string;
    };
    value: number;
  }[];
  subjects: {
    id: string;
    name: string;
  }[];
}

const MeasurementBySubject: React.FC<IMeasurementBySubjectProps> = ({ measurements, subjects }) => {
  const group = groupBySubject(measurements);
  const subjectsWithMeasurements = arrayOfIds(group);
  const subjectsWithoutMeasurements = subjects.filter(subject => {
    return !subjectsWithMeasurements.includes(subject.id);
  });
  const allSubjects = [...group, ...subjectsWithoutMeasurements];

  return (
    <div>
      {allSubjects.map(subject => (
        <div key={subject.id} className="pt3 pb1" data-testid={`measurement-${subject.slug}`}>
          <h4 className="f7 fw6 mt0 mb1" data-testid="measurement-subject">
            {subject.name}
          </h4>
          {subject.measurements &&
            subject.measurements.length > 0 &&
            sortBy(subject.measurements, meas => meas.tracker.name).map(({ tracker, value }) => (
              <Tracker
                key={tracker.id}
                className="bt b--light-gray pv1"
                name={tracker.name}
                tracker={tracker}
                value={value}
              />
            ))}

          {!subject.measurements && (
            <div className="bt b--light-gray">
              <span className="db light-tan f7 i serif pv2">No measurements</span>
            </div>
          )}
        </div>
      ))}
      {allSubjects.length === 0 && <p className="f6 serif light-tan i mb0">No Data</p>}
    </div>
  );
};

export default MeasurementBySubject;
